import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'

export const useReportSetReferenceMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { analyticalNumber: string, componentSid: string, analysisType?: number }) =>
            hcaClientFactory.reportsApi.setIsReference(payload.analyticalNumber, payload.componentSid, payload.analysisType),
        onSuccess: async (response, payload) => {
            await queryClient.invalidateQueries({ queryKey: ['reports', 'details', payload.analyticalNumber] })
        },
    })
}
